/* tslint:disable: member-ordering*/
import { of as observableOf } from 'rxjs';

import {
  share,
  catchError,
  map,
  switchMap,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store'; 
import { ErrorsType } from '@toro/common/shared/enum/errors.type';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { BackendService } from '@toro/common/shared/services/backend/backend.service'; 
import { DefaultResponse } from '@toro/common/shared/models/form/DefaultResponse';
import { StockResearchTrendAction } from './stock-research-trend.action';

@Injectable()
export class StockResearchTrendEffects {
    constructor(
        private actions$: Actions<StockResearchTrendAction>,
        private dataService: BackendService,
        private store$: Store<AppState>
    ) {}

    /**
     * Obtem tendências de uma empresa
     * @method getTrend
     */
    getTrend$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockResearchTrendAction.getTrend),
            switchMap((action) => {
                return this.dataService.get<DefaultResponse>(`research/trend?trendPeriod=${action.payload.time}&symbol=${action.payload.symbol}`)
                    .pipe(
                        map((result) => {
                            if (result.hasAlerta) {
                                return {
                                    type: StockResearchTrendAction.getTrendError,
                                    payload: { type: ErrorsType.Warning, value: result.messages }
                                };
                            }
                            if (result.hasError) {
                                return {
                                    type: StockResearchTrendAction.getTrendError,
                                    payload: { type: ErrorsType.Error, value: result.messages }
                                };
                            }
                            if (result.ok && result.hasValue) {
                                return { type: StockResearchTrendAction.getTrendSuccess, payload: result.value };
                            }
                            return { type: StockResearchTrendAction.getTrendSuccess, payload: result.value };
                        }),
                        catchError(error => observableOf({ type: StockResearchTrendAction.getTrendError, payload: error })),
                    );
            }),
            share(),
        )
    );

    /**
     * Obtem tendências de uma empresa
     * @method getShortTrend
     */
    getShortTrend$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockResearchTrendAction.getShortTrend),
            switchMap((action) => {
                return this.dataService.get<DefaultResponse>(`research/trendsshortterm`)
                    .pipe(
                        map((result) => {
                            if (result.hasAlerta) {
                                return {
                                    type: StockResearchTrendAction.getShortTrendError,
                                    payload: { type: ErrorsType.Warning, value: result.messages }
                                };
                            }
                            if (result.hasError) {
                                return {
                                    type: StockResearchTrendAction.getShortTrendError,
                                    payload: { type: ErrorsType.Error, value: result.messages }
                                };
                            }
                            if (result.ok && result.hasValue) {
                                return { type: StockResearchTrendAction.getShortTrendSuccess, payload: result.value };
                            }
                            return { type: StockResearchTrendAction.getShortTrendSuccess, payload: result.value };
                        }),
                        catchError(error => observableOf({ type: StockResearchTrendAction.getShortTrendError, payload: error })),
                    );
            }),
            share(),
        )
    );

    /**
     * Obtem tendência mensal de uma empresa
     * @method getCompanyTrend
     */
    getCompanyTrend$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockResearchTrendAction.getCompanyTrend),
            switchMap((action) => {
                return this.dataService.get<DefaultResponse>(`research/companytrend?symbol=${action.payload.symbol}`)
                    .pipe(
                        map((result) => {
                            if (result.hasAlerta) {
                                return {
                                    type: StockResearchTrendAction.getCompanyTrendError,
                                    payload: { type: ErrorsType.Warning, value: result.messages }
                                };
                            }
                            if (result.hasError) {
                                return {
                                    type: StockResearchTrendAction.getCompanyTrendError,
                                    payload: { type: ErrorsType.Error, value: result.messages }
                                };
                            }
                            if (result.ok && result.value) {
                                return { type: StockResearchTrendAction.getCompanyTrendSuccess, payload: result.value };
                            }

                            return { type: StockResearchTrendAction.getCompanyTrendSuccess, payload: result };
                        }),
                        catchError(error => observableOf({ type: StockResearchTrendAction.getCompanyTrendError, payload: error })),
                    );
            }),
            share(),
        )
    );

    /**
     * Obtem informação se ativo é pouco negociado
     * @method getLittleTraded
     */
    getLittleTraded$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockResearchTrendAction.getLittleTraded),
            switchMap((action) => {
                return this.dataService.get<DefaultResponse>(`posrisk/islittletraded?symbol=${action.payload.symbol}`)
                    .pipe(
                        map((result) => {
                            if (result.hasAlerta) {
                                return {
                                    type: StockResearchTrendAction.getLittleTradedError,
                                    payload: { type: ErrorsType.Warning, value: result.messages }
                                };
                            }
                            if (result.hasError) {
                                return {
                                    type: StockResearchTrendAction.getLittleTradedError,
                                    payload: { type: ErrorsType.Error, value: result.messages }
                                };
                            }
                            if (result.ok && result.hasValue) {
                                return { type: StockResearchTrendAction.getLittleTradedSuccess, payload: result.value };
                            }
                            
                            return { type: StockResearchTrendAction.getLittleTradedSuccess, payload: result }; 
                        }),
                        catchError(error => observableOf({ type: StockResearchTrendAction.getLittleTradedError, payload: error })),
                    );
            }),
            share(),
        )
    );
}